import { RootState } from 'store/store';

export const membersSelector = (state: RootState) => state.member.members;
export const memberOneSelector = (state: RootState) => state.member.currentMember;
export const memberMySelector = (state: RootState) => state.member.myMember;
export const currentOneLeagueStatusSelector = (state: RootState) => state.member.currentMemberStatus;
